// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Content Styles */
.custom-modal .ant-modal-content {
  padding: 0 0px 10px 0 !important;
  border-radius: 12px;
}

.custom-modal-header {
  color: white;
  background-color: #040724;
  padding: 10px 0px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin: 0;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.custom-modal .ant-modal-body {
  padding: 16px;
}

.custom-modal .ant-form {
  display: flex !important;
  flex-wrap: wrap;
}

.custom-modal .ant-modal-footer {
  padding: 10px 20px;
}

/* Button Styles */
.custom-modal .ant-btn-primary {
  background-color: #040724;
}

.custom-modal .ant-btn-disabled:hover {
  background-color: #040724 !important;
}

.custom-modal .ant-radio-button-wrapper:not(:first-child)::before {
  background-color: white !important;
}

/* Radio Button Styles */
.custom-modal .ant-radio-group {
  display: flex;
}

.custom-modal .ant-radio-button-wrapper {
  border-radius: 40px !important;
  border: 1px solid #d9d9d9;
}

.custom-modal .ant-radio-button-wrapper:not(:first-child)::before {
  background-color: transparent !important;
}

/* For selected radio button background */
.custom-modal
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background-color: #36c6d3 !important;
  border-color: #36c6d3 !important;
  color: white !important;
}

/* Ensure the border is consistent with the green background */
.custom-modal
  .ant-radio-button-wrapper-checked:not(
    .ant-radio-button-wrapper-disabled
  )::before {
  background-color: #36c6d3 !important;
}

/* Remove default focus styles */
.custom-modal
  .ant-radio-button-wrapper-checked:not(
    .ant-radio-button-wrapper-disabled
  ):focus-within {
  box-shadow: none;
}

/* Hover styles for unselected buttons */
.custom-modal .ant-radio-button-wrapper:hover {
  color: #36c6d3;
}

/* Hover styles for selected button */
.custom-modal
  .ant-radio-button-wrapper-checked:not(
    .ant-radio-button-wrapper-disabled
  ):hover {
  color: white !important;
  background-color: #2eadb9 !important;
  border-color: #2eadb9 !important;
}

/* Radio Group Styles */
.custom-modal .ant-radio-group {
  display: flex;
  gap: 8px;
}

/* Style for the custom radio button container */
.custom-radio-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  position: relative;
  margin-left: "10px";
}

/* Hidden default radio input */
.custom-radio-input {
  display: none;
}

/* Custom radio button label (acts as the visible button) */
.custom-radio-label {
  display: inline-block;
  padding: 10px 3px;
  border-radius: 4px;
  border: 2px solid #ccc;
  background-color: transparent;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.3s, border-color 0.3s;
  text-align: center;
  min-width: 120px;
  text-transform: capitalize;
}

/* Custom radio button when selected */
.custom-radio-input:checked + .custom-radio-label {
  background-color: #2eadb9;
  color: white;
  border-color: #2eadb9;
}

.ant-radio-button-wrapper:first-child {
  border-radius: 0px;
}

.ant-radio-button-wrapper:last-child {
  border-radius: 0px;
}

.custom-modal .flag-dropdown {

}

.custom-modal .ant-btn:hover {
background-color: black !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/ReusableModal.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,SAAS;EACT,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,8DAA8D;AAC9D;;;;EAIE,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;;;;EAIE,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;;;;EAIE,uBAAuB;EACvB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;AAEA;;AAEA;AACA,kCAAkC;AAClC","sourcesContent":["/* Modal Content Styles */\n.custom-modal .ant-modal-content {\n  padding: 0 0px 10px 0 !important;\n  border-radius: 12px;\n}\n\n.custom-modal-header {\n  color: white;\n  background-color: #040724;\n  padding: 10px 0px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  margin: 0;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.custom-modal .ant-modal-body {\n  padding: 16px;\n}\n\n.custom-modal .ant-form {\n  display: flex !important;\n  flex-wrap: wrap;\n}\n\n.custom-modal .ant-modal-footer {\n  padding: 10px 20px;\n}\n\n/* Button Styles */\n.custom-modal .ant-btn-primary {\n  background-color: #040724;\n}\n\n.custom-modal .ant-btn-disabled:hover {\n  background-color: #040724 !important;\n}\n\n.custom-modal .ant-radio-button-wrapper:not(:first-child)::before {\n  background-color: white !important;\n}\n\n/* Radio Button Styles */\n.custom-modal .ant-radio-group {\n  display: flex;\n}\n\n.custom-modal .ant-radio-button-wrapper {\n  border-radius: 40px !important;\n  border: 1px solid #d9d9d9;\n}\n\n.custom-modal .ant-radio-button-wrapper:not(:first-child)::before {\n  background-color: transparent !important;\n}\n\n/* For selected radio button background */\n.custom-modal\n  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  background-color: #36c6d3 !important;\n  border-color: #36c6d3 !important;\n  color: white !important;\n}\n\n/* Ensure the border is consistent with the green background */\n.custom-modal\n  .ant-radio-button-wrapper-checked:not(\n    .ant-radio-button-wrapper-disabled\n  )::before {\n  background-color: #36c6d3 !important;\n}\n\n/* Remove default focus styles */\n.custom-modal\n  .ant-radio-button-wrapper-checked:not(\n    .ant-radio-button-wrapper-disabled\n  ):focus-within {\n  box-shadow: none;\n}\n\n/* Hover styles for unselected buttons */\n.custom-modal .ant-radio-button-wrapper:hover {\n  color: #36c6d3;\n}\n\n/* Hover styles for selected button */\n.custom-modal\n  .ant-radio-button-wrapper-checked:not(\n    .ant-radio-button-wrapper-disabled\n  ):hover {\n  color: white !important;\n  background-color: #2eadb9 !important;\n  border-color: #2eadb9 !important;\n}\n\n/* Radio Group Styles */\n.custom-modal .ant-radio-group {\n  display: flex;\n  gap: 8px;\n}\n\n/* Style for the custom radio button container */\n.custom-radio-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  position: relative;\n  margin-left: \"10px\";\n}\n\n/* Hidden default radio input */\n.custom-radio-input {\n  display: none;\n}\n\n/* Custom radio button label (acts as the visible button) */\n.custom-radio-label {\n  display: inline-block;\n  padding: 10px 3px;\n  border-radius: 4px;\n  border: 2px solid #ccc;\n  background-color: transparent;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background-color 0.3s, border-color 0.3s;\n  text-align: center;\n  min-width: 120px;\n  text-transform: capitalize;\n}\n\n/* Custom radio button when selected */\n.custom-radio-input:checked + .custom-radio-label {\n  background-color: #2eadb9;\n  color: white;\n  border-color: #2eadb9;\n}\n\n.ant-radio-button-wrapper:first-child {\n  border-radius: 0px;\n}\n\n.ant-radio-button-wrapper:last-child {\n  border-radius: 0px;\n}\n\n.custom-modal .flag-dropdown {\n\n}\n\n.custom-modal .ant-btn:hover {\nbackground-color: black !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
